"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = exports.TAG = exports.TYPES = void 0;
exports.TYPES = {
    ISaReportService: Symbol.for("@al/event-tracking/sensor-analytics/ISaReportService"),
    ISensorAnalyticsService: Symbol.for("@al/event-tracking/sensor-analytics/ISensorAnalyticsService"),
    IClickService: Symbol.for("@al/event-tracking/sensor-analytics/IClickService"),
    ISendToSaService: Symbol.for("@al/event-tracking/sensor-analytics/ISendToSaService"),
    ILeaveOpsService: Symbol.for("@al/event-tracking/sensor-analytics/ILeaveOpsService"),
    IInputService: Symbol.for("@al/event-tracking/sensor-analytics/IInputService"),
};
exports.TAG = {
    SDKConfigService: Symbol.for("@al/event-tracking/sensor-analytics/tag/SDKConfigService"),
    PageConfigService: Symbol.for("@al/event-tracking/sensor-analytics/tag/PageConfigService"),
    ClickEventObserver: Symbol.for("@al/event-tracking/sensor-analytics/tag/ClickEventObserver"),
    InputEventObserver: Symbol.for("@al/event-tracking/sensor-analytics/tag/InputEventObserver"),
    PasteEventObserver: Symbol.for("@al/event-tracking/sensor-analytics/tag/PasteEventObserver"),
    ExposeEventObserver: Symbol.for("@al/event-tracking/sensor-analytics/tag/ExposeEventObserver"),
    EventOrderBucket: Symbol.for("@al/event-tracking/sensor-analytics/tag/EventOrderBucket"),
    BeforeSendTask: Symbol.for("@al/event-tracking/sensor-analytics/tag/BeforeSendTask"),
    TimeProcessorTask: Symbol.for("@al/event-tracking/sensor-analytics/tag/TimeProcessorTask"),
    CleanDataTask: Symbol.for("@al/event-tracking/sensor-analytics/tag/CleanDataTask"),
    SendToSaTask: Symbol.for("@al/event-tracking/sensor-analytics/tag/SendToSaTask"),
    VisibilityEventObserver: Symbol.for("@al/event-tracking/sensor-analytics/tag/VisibilityEventObserver"),
    LocalStoreService: Symbol.for("@al/event-tracking/sensor-analytics/tag/LocalStoreService"),
    SessionStoreService: Symbol.for("@al/event-tracking/sensor-analytics/tag/SessionStoreService"),
};
var EventType;
(function (EventType) {
    EventType["View"] = "WebViewScreen";
    EventType["Click"] = "WebClick";
    EventType["PopClick"] = "PopClick";
    EventType["PopView"] = "PopView";
    EventType["Expose"] = "WebExposure";
    EventType["Input"] = "WebInput";
    EventType["ActivityClick"] = "ActivityWebClick";
    EventType["ActivityView"] = "ActivityWebView";
    EventType["ActivityInput"] = "ActivityWebInput";
})(EventType = exports.EventType || (exports.EventType = {}));
